<template>
  <el-card>
    <div class="adv-addImg">
      <el-button icon="el-icon-arrow-left" @click="back()">取消</el-button>
      <!--宣传位详情-->
      <el-form :model="realForm">
        <!-- <el-form-item label="标题:" label-width="100px">
          <span>{{realForm.name}}</span>
        </el-form-item>-->
        <el-form-item label="调显码:" label-width="100px">
          <span>{{realForm.code}}</span>
        </el-form-item>
        <el-form-item label="形式:" label-width="100px">
          <span>{{realForm.type=='1'?'单图':'轮播'}}</span>
        </el-form-item>
      </el-form>
      <el-divider></el-divider>

      <!--添加宣传位内容-->
      <el-form ref="imgForm" :model="imgForm" :rules="rules" class="demo-ruleForm" label-width="100px">
        <!-- <el-input v-model="imgForm.groupId" type="hidden"></el-input> -->
        <el-form-item label="标题：" prop="title">
          <el-input style="width: 350px" v-model="imgForm.title"></el-input>
        </el-form-item>
        <el-form-item label="简介：" prop="intro">
          <el-input type="textarea" style="width: 350px" v-model="imgForm.intro"></el-input>
        </el-form-item>
        <el-form-item label="显示排序:" label-width="100px" prop="sortId">
          <el-input v-model="imgForm.sortId" style="width: 350px" @input="changetonum"></el-input>
        </el-form-item>
        <el-form-item label="链接:" label-width="100px">
          <el-input v-model="imgForm.clickUrl" style="width: 350px"></el-input>
        </el-form-item>
        <el-form-item label="弹出链接:" label-width="100px" prop="isClick">
          <el-radio-group v-model="imgForm.isClick" @change="selectType">
            <el-radio-button label="Y">弹出</el-radio-button>
            <el-radio-button label="N">不弹出</el-radio-button>
          </el-radio-group>
        </el-form-item>
        <el-form-item label="图片内容:" label-width="100px">
          <el-upload
            class="avatar-uploader"
            action="/api/v1/advertise/uploadImgs"
            :show-file-list="false"
            :on-success="handleAvatarSuccess"
            :before-upload="beforeAvatarUpload"
            :on-preview="handlePictureCardPreview"
            :headers="header"
            name="imgFiles"
          >
            <img v-if="dialogImageUrl" :src="dialogImageUrl" class="avatar" />
            <i v-else class="el-icon-plus avatar-uploader-icon"></i>
          </el-upload>
        </el-form-item>
        <el-divider></el-divider>
        <el-form-item>
          <el-button type="primary" @click="submitForm('imgForm')">保存</el-button>
        </el-form-item>
      </el-form>
    </div>
  </el-card>
</template>

<script>
import qs from 'qs'
export default {
  data () {
    return {
      realForm: {},
      imgForm: {
        groupId: this.$route.query.id,
        sortId: '',
        clickUrl: '',
        isClick: 'Y',
        url: ''
      },
      // isRadio: "弹出",
      rules: {
        name: [
          {
            required: true,
            message: '此项为必填项',
            trigger: 'red'
          }
        ],
        sortId: [{ required: true, message: '此项为必填项', trigger: 'blur' }],
        isClick: [
          { required: true, message: '请选择是否弹出链接', trigger: 'change' }
        ],
        title: [{required: true, message: '请输入标题', trigger: 'blur'}],
        intro: [{required: true, message: '请输入简介', trigger: 'blur'}]
      },
      dialogImageUrl: ''
    }
  },
  computed: {
    header: function () {
      return {
        token: window.localStorage.getItem('token')
      }
    }
  },
  methods: {
    // 宣传位信息
    getAdvertiseById: async function () {
      var id = this.$route.query.id
      var res = await this.$http.get(`/v1/advertise/advertiselist?id=${id}`)
      var { code, message, data } = res.data
      if (code == 0) {
        this.realForm = data
      }
    },
    // 宣传位详情
    getAdvertiseImg: async function () {
      var imgId = this.$route.query.imgId
      console.log('id', imgId)
      var res = await this.$http.get(`/v1/advertise/getPicInfo?id=${imgId}`)
      var { code, message, data } = res.data
      if (code == 0) {
        this.imgForm = data
        // this.isRadio = data.isClick == "Y" ? "弹出" : "不弹出";
        this.groupid = this.$route.query.id
        this.dialogImageUrl = data.url
      }
    },
    // 选择类别
    selectType: function () {
      // this.imgForm.isClick = this.isRadio == "弹出" ? "Y" : "N";
      console.log('弹出类型', this.imgForm.isClick)
    },
    //
    handlePictureCardPreview: function (file) {
      console.log(file)
      this.dialogImageUrl = file.url
      this.dialogVisible = true
    },
    handleAvatarSuccess: function (res, file, filelist) {
      console.log(file)
      // this.imgForm.url = URL.createObjectURL(file.raw);
      var { code, message, data } = res
      if (code == 0) {
        this.imgForm.url = data
        this.dialogImageUrl = data
      } else {
        this.$message.error(message)
      }
    },
    beforeAvatarUpload: function (file) {
      const isJPG = file.type === 'image/jpeg'
      const isLt2M = file.size / 1024 / 1024 < 2

      if (!isJPG) {
        this.$message.error('上传图片只能是 JPG 格式!')
      }
      if (!isLt2M) {
        this.$message.error('上传图片大小不能超过 2MB!')
      }
      return isJPG && isLt2M
    },
    submitForm: function (imgForm) {
      this.$refs[imgForm].validate(async valid => {
        if (valid) {
          var res = await this.$http.post(
            `/v1/advertise/advertiseDetail`,
            qs.stringify(this.imgForm)
          )
          var { code, message, data } = res.data
          if (code == 0) {
            var advertiseId = this.$route.query.id
            var advertiseCode = this.$route.query.code
            this.$router.push({
              path: `/AdvertiseDetail`,
              query: { id: advertiseId, code: advertiseCode }
            })
            this.$message.success('添加/编辑成功')
          } else {
            this.$message.error(message)
          }
        }
      })
    },
    resetForm: function (formName) {
      this.$refs[formName].resetFields()
    },
    back: function () {
      var advertiseId = this.$route.query.id
      var advertiseCode = this.$route.query.code
      this.$router.push({
        path: `/AdvertiseDetail`,
        query: { id: advertiseId, code: advertiseCode }
      })
    },
    changetonum: function () {
      var res = this.imgForm.sortId
      this.imgForm.sortId = res.replace(/[^\d]/g, '')
      /* addperson.orderId=value.replace(/[^\d]/g,'')" */
    }

  },
  mounted () {
    this.getAdvertiseById()
    this.getAdvertiseImg()
  }
}
</script>

<style scoped lang="scss">
//
// .avatar-uploader .el-upload {
//   border: 1px dashed #d9d9d9;
//   border-radius: 6px;
//   cursor: pointer;
//   position: relative;
//   overflow: hidden;
// }
// .avatar-uploader .el-upload:hover {
//   border-color: #409eff;
// }
// .avatar-uploader-icon {
//   font-size: 28px;
//   color: #8c939d;
//   width: 178px;
//   height: 178px;
//   line-height: 178px;
//   text-align: center;
// }
// .avatar {
//   width: 178px;
//   height: 178px;
//   display: block;
// }
// .el-tag + .el-tag {
//   margin-left: 10px;
// }
// .button-new-tag {
//   margin-left: 10px;
//   height: 32px;
//   line-height: 30px;
//   padding-top: 0;
//   padding-bottom: 0;
// }
// .input-new-tag {
//   width: 90px;
//   margin-left: 10px;
//   vertical-align: bottom;
// }
</style>
<style>
.adv-addImg .avatar-uploader .el-upload {
  border: 1px dashed #d9d9d9;
  border-radius: 6px;
  cursor: pointer;
  position: relative;
  overflow: hidden;
}
.adv-addImg .avatar-uploader .el-upload:hover {
  border-color: #409eff;
}
.adv-addImg .avatar-uploader-icon {
  font-size: 28px;
  color: #8c939d;
  width: 178px;
  height: 178px;
  line-height: 178px;
  text-align: center;
}
.adv-addImg .avatar {
  width: 178px;
  height: 178px;
  display: block;
}
</style>



// WEBPACK FOOTER //
// src/components/backgroundMg/advertise-mg/AdvertiseAddImg.vue